import { render, staticRenderFns } from "./PhoneLabel.vue?vue&type=template&id=27fbd1c1&scoped=true&"
import script from "./PhoneLabel.vue?vue&type=script&lang=ts&"
export * from "./PhoneLabel.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneLabel.vue?vue&type=style&index=0&id=27fbd1c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fbd1c1",
  null
  
)

export default component.exports